import { render, staticRenderFns } from "./cameraPass.vue?vue&type=template&id=05eb4787&scoped=true&"
import script from "./cameraPass.vue?vue&type=script&lang=js&"
export * from "./cameraPass.vue?vue&type=script&lang=js&"
import style0 from "./cameraPass.vue?vue&type=style&index=0&id=05eb4787&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05eb4787",
  null
  
)

export default component.exports